import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const SUBJECTS = [
  { value: 'sales', label: 'Satış / demo isteği', email: 'satis@onxflow.com' },
  { value: 'support', label: 'Teknik destek', email: 'destek@onxflow.com' },
  { value: 'general', label: 'Genel iletişim', email: 'iletisim@onxflow.com' },
];

export default function Contact() {
  const [form, setForm] = useState({
    name: '', email: '', company: '', subject: 'sales', message: '', kvkk: false,
  });
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    const prevTitle = document.title;
    document.title = 'OnxFlow — İletişim';
    return () => { document.title = prevTitle; };
  }, []);

  const interTight = "'Inter Tight', system-ui, -apple-system, sans-serif";

  const update = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message || !form.kvkk) return;
    setSubmitted(true);
  };

  const reset = () => {
    setSubmitted(false);
    setForm({ name: '', email: '', company: '', subject: 'sales', message: '', kvkk: false });
  };

  return (
    <div
      className="bg-white min-h-screen"
      style={{
        fontFamily: "'Inter Tight', system-ui, -apple-system, sans-serif",
        '--accent': '#1E5FA8',
      }}
    >
      <LandingNav />

      {/* Hero */}
      <section className="relative overflow-hidden bg-white">
        <div
          className="absolute inset-0 pointer-events-none opacity-50"
          style={{
            backgroundImage:
              'linear-gradient(to right, #0a0e1408 1px, transparent 1px), linear-gradient(to bottom, #0a0e1408 1px, transparent 1px)',
            backgroundSize: '64px 64px',
            maskImage: 'radial-gradient(ellipse 70% 60% at 50% 30%, #000 40%, transparent 80%)',
            WebkitMaskImage: 'radial-gradient(ellipse 70% 60% at 50% 30%, #000 40%, transparent 80%)',
          }}
        />
        <div
          className="absolute pointer-events-none"
          style={{
            top: '-200px',
            left: '50%',
            transform: 'translateX(-50%)',
            width: '900px',
            height: '500px',
            background:
              'radial-gradient(ellipse, color-mix(in oklch, #1E5FA8 16%, transparent), transparent 60%)',
            filter: 'blur(60px)',
          }}
        />
        <div className="relative max-w-[1100px] mx-auto px-8 pt-20 pb-10 text-center">
          <div className="inline-flex items-center gap-2 h-7 px-3 rounded-full border border-slate-200 bg-white shadow-[0_1px_2px_rgba(0,0,0,0.04)]">
            <span
              className="w-1.5 h-1.5 rounded-full"
              style={{ background: '#1E5FA8', boxShadow: '0 0 6px #1E5FA8' }}
            />
            <span
              className="text-[10.5px] uppercase tracking-[0.16em] text-slate-700"
              style={{ fontFamily: "'JetBrains Mono', ui-monospace, monospace" }}
            >
              İletişim
            </span>
          </div>
          <h1
            className="mt-7 text-[56px] md:text-[76px] leading-[0.96] tracking-[-0.035em] font-semibold text-slate-950 mx-auto max-w-[900px]"
            style={{ fontFamily: interTight }}
          >
            Sorularınızı{' '}
            <span
              className="italic font-light"
              style={{
                background:
                  'linear-gradient(90deg, #1E5FA8, color-mix(in oklch, #1E5FA8 55%, #6c4ad9))',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
              }}
            >
              yanıtlayalım.
            </span>
          </h1>
          <p className="mt-7 text-[17px] text-slate-600 max-w-[620px] mx-auto leading-[1.55]">
            Demo planlama, plan seçimi, teknik sorular veya kurumsal teklifler için ekibimiz hazır.
            En uygun kanaldan ulaşın, en kısa sürede yanıt verelim.
          </p>
        </div>
      </section>

      {/* Form */}
      <section className="bg-white pb-24">
        <div className="max-w-[820px] mx-auto px-8">
          <div
            className="rounded-2xl border border-slate-200 bg-white p-8 md:p-10"
            style={{ boxShadow: '0 4px 16px -8px rgba(15,23,42,0.08)' }}
          >
            {submitted ? (
              <SuccessState onReset={reset} />
            ) : (
              <form onSubmit={submit}>
                <div
                  className="text-[10.5px] uppercase tracking-[0.16em] text-slate-500 mb-2"
                  style={{ fontFamily: "'JetBrains Mono', ui-monospace, monospace" }}
                >
                  — Form ile gönder
                </div>
                <h2
                  className="text-[24px] font-semibold text-slate-950 tracking-tight"
                  style={{ fontFamily: interTight }}
                >
                  Mesaj bırakın
                </h2>
                <p className="mt-2 text-[13.5px] text-slate-600">
                  Tüm alanlar gereklidir. Yanıt süresi: 1 iş günü.
                </p>

                <div className="mt-7 grid grid-cols-1 md:grid-cols-2 gap-4">
                  <Field label="Ad Soyad" required>
                    <input
                      value={form.name}
                      onChange={(e) => update('name', e.target.value)}
                      placeholder="Örn: Mehmet Yılmaz"
                      required
                      className="w-full h-11 px-3.5 rounded-lg border border-slate-200 bg-white text-[14px] outline-none focus:border-slate-400 transition"
                    />
                  </Field>
                  <Field label="Kurumsal e-posta" required>
                    <input
                      type="email"
                      value={form.email}
                      onChange={(e) => update('email', e.target.value)}
                      placeholder="ad@sirket.com"
                      required
                      className="w-full h-11 px-3.5 rounded-lg border border-slate-200 bg-white text-[14px] outline-none focus:border-slate-400 transition"
                    />
                  </Field>
                  <Field label="Şirket">
                    <input
                      value={form.company}
                      onChange={(e) => update('company', e.target.value)}
                      placeholder="Şirket adı (opsiyonel)"
                      className="w-full h-11 px-3.5 rounded-lg border border-slate-200 bg-white text-[14px] outline-none focus:border-slate-400 transition"
                    />
                  </Field>
                  <Field label="Konu" required>
                    <select
                      value={form.subject}
                      onChange={(e) => update('subject', e.target.value)}
                      required
                      className="w-full h-11 px-3.5 rounded-lg border border-slate-200 bg-white text-[14px] outline-none focus:border-slate-400 transition appearance-none"
                      style={{
                        backgroundImage:
                          "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 16 16' fill='none'><path d='M4 6l4 4 4-4' stroke='%2364748b' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/></svg>\")",
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'right 12px center',
                        paddingRight: '36px',
                      }}
                    >
                      {SUBJECTS.map((s) => (
                        <option key={s.value} value={s.value}>
                          {s.label}
                        </option>
                      ))}
                    </select>
                  </Field>
                </div>

                <Field label="Mesajınız" required className="mt-4">
                  <textarea
                    value={form.message}
                    onChange={(e) => update('message', e.target.value)}
                    placeholder="Ekibinize uygun planı bulmamıza yardımcı olacak detayları paylaşın."
                    required
                    rows={5}
                    className="w-full px-3.5 py-3 rounded-lg border border-slate-200 bg-white text-[14px] outline-none focus:border-slate-400 transition resize-y"
                  />
                </Field>

                <label className="mt-5 flex items-start gap-3 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={form.kvkk}
                    onChange={(e) => update('kvkk', e.target.checked)}
                    required
                    className="mt-[3px] w-4 h-4 rounded border-slate-300 cursor-pointer"
                    style={{ accentColor: '#1E5FA8' }}
                  />
                  <span className="text-[12.5px] text-slate-600 leading-[1.5]">
                    Kişisel verilerimin{' '}
                    <button
                      type="button"
                      className="underline decoration-slate-300 underline-offset-2 hover:text-slate-900 transition bg-transparent border-0 p-0 cursor-pointer text-inherit"
                      onClick={(e) => e.preventDefault()}
                    >
                      KVKK Aydınlatma Metni
                    </button>
                    'ne uygun şekilde işlenmesini ve bu form aracılığıyla paylaşılan bilgilerin
                    saklanmasını kabul ediyorum.
                  </span>
                </label>

                <button
                  type="submit"
                  disabled={!form.name || !form.email || !form.message || !form.kvkk}
                  className="mt-7 inline-flex items-center gap-2 h-12 px-6 rounded-xl text-[14.5px] font-semibold text-white shadow-md transition hover:brightness-110 disabled:opacity-40 disabled:cursor-not-allowed"
                  style={{ background: '#1E5FA8' }}
                >
                  Mesajı gönder
                  <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
                    <path
                      d="M3 8h10m0 0L9 4m4 4l-4 4"
                      stroke="currentColor"
                      strokeWidth="1.6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
              </form>
            )}
          </div>
        </div>
      </section>

      <LandingFooter />
    </div>
  );
}

function Field({ label, required, children, className = '' }) {
  return (
    <label className={`block ${className}`}>
      <div
        className="text-[10.5px] uppercase tracking-[0.14em] text-slate-600 mb-1.5"
        style={{ fontFamily: "'JetBrains Mono', ui-monospace, monospace" }}
      >
        {label}
        {required && <span className="text-rose-500 ml-0.5">*</span>}
      </div>
      {children}
    </label>
  );
}

function SuccessState({ onReset }) {
  return (
    <div className="text-center py-8">
      <div
        className="w-14 h-14 mx-auto rounded-full flex items-center justify-center"
        style={{ background: 'color-mix(in oklch, #1E5FA8 14%, white)', color: '#1E5FA8' }}
      >
        <svg width="22" height="22" viewBox="0 0 16 16" fill="none">
          <path
            d="M3 8.5l3.5 3L13 5"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
      <h3
        className="mt-5 text-[22px] font-semibold text-slate-950 tracking-tight"
        style={{ fontFamily: "'Inter Tight', system-ui, sans-serif" }}
      >
        Mesajınız iletildi
      </h3>
      <p className="mt-2 text-[14px] text-slate-600 max-w-[420px] mx-auto leading-[1.55]">
        Ekibimiz mesajınızı aldı. En kısa sürede belirttiğiniz e-posta adresinden size dönüş
        yapılacaktır.
      </p>
      <button
        onClick={onReset}
        className="mt-6 inline-flex items-center h-10 px-5 rounded-lg text-[13.5px] font-medium text-slate-700 border border-slate-200 bg-white hover:bg-slate-50 transition"
      >
        Yeni mesaj gönder
      </button>
    </div>
  );
}

function LandingNav() {
  return (
    <header className="sticky top-0 z-40 backdrop-blur-md bg-white/75 border-b border-black/5">
      <div className="max-w-[1280px] mx-auto px-8 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5 group">
          <div
            className="w-8 h-8 rounded-lg flex items-center justify-center text-white font-bold text-[15px] tracking-tight"
            style={{ background: '#1E5FA8' }}
          >
            X
          </div>
          <div className="leading-none">
            <div className="font-bold text-[16px] tracking-tight text-slate-900">OnxFlow</div>
            <div
              className="text-[9px] uppercase tracking-[0.14em] text-slate-500 mt-0.5"
              style={{ fontFamily: "'JetBrains Mono', ui-monospace, monospace" }}
            >
              Proje Yönetimi
            </div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-8 text-[14px] text-slate-700">
          <Link to="/" className="hover:text-slate-950 transition">
            Ürün
          </Link>
          <Link to="/pricing" className="hover:text-slate-950 transition">
            Fiyatlandırma
          </Link>
          <Link to="/contact" className="hover:text-slate-950 transition">
            İletişim
          </Link>
        </nav>

        <div className="flex items-center gap-2">
          <Link
            to="/"
            className="hidden sm:inline-flex items-center h-9 px-4 text-[14px] font-medium text-slate-700 hover:text-slate-950 transition"
          >
            Giriş yap
          </Link>
          <Link
            to="/"
            className="inline-flex items-center h-9 px-4 rounded-lg text-[13.5px] font-semibold text-white transition hover:brightness-110 shadow-sm"
            style={{ background: '#1E5FA8' }}
          >
            Ücretsiz başla
          </Link>
        </div>
      </div>
    </header>
  );
}

function LandingFooter() {
  return (
    <footer className="bg-slate-950 text-slate-400 pt-16 pb-10">
      <div className="max-w-[1280px] mx-auto px-8">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 pb-12 border-b border-white/10">
          <div className="col-span-2">
            <div className="flex items-center gap-2.5">
              <div
                className="w-8 h-8 rounded-lg flex items-center justify-center text-white font-bold text-[15px]"
                style={{ background: '#1E5FA8' }}
              >
                X
              </div>
              <div className="leading-none">
                <div className="font-bold text-[16px] text-white">OnxFlow</div>
                <div
                  className="text-[9px] uppercase tracking-[0.14em] text-slate-500 mt-0.5"
                  style={{ fontFamily: "'JetBrains Mono', ui-monospace, monospace" }}
                >
                  Proje Yönetimi v2.0
                </div>
              </div>
            </div>
            <p className="mt-4 text-[13px] leading-[1.6] max-w-[300px]">
              Görev panosundan onaylara, raporlamadan rol yönetimine — ekipler için kurumsal proje
              platformu.
            </p>
          </div>
          <FooterCol
            title="Ürün"
            items={[
              { l: 'Görev Panosu', h: '/' },
              { l: 'İş Akışları', h: '/' },
              { l: 'Raporlar', h: '/' },
              { l: 'Fiyatlandırma', h: '/pricing' },
            ]}
          />
          <FooterCol
            title="Şirket"
            items={[
              { l: 'Hakkımızda', h: '#' },
              { l: 'İletişim', h: '/contact' },
              { l: 'KVKK', h: '#' },
              { l: 'Şartlar', h: '#' },
            ]}
          />
          <FooterCol
            title="Destek"
            items={[
              { l: 'Yardım merkezi', h: '#' },
              { l: 'Sürüm notları', h: '#' },
              { l: 'Durum sayfası', h: '#' },
              { l: 'Geri bildirim', h: '/contact' },
            ]}
          />
        </div>
        <div className="pt-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div
            className="text-[10.5px] uppercase tracking-[0.16em]"
            style={{ fontFamily: "'JetBrains Mono', ui-monospace, monospace" }}
          >
            © 2026 OnxFlow · Tüm hakları saklıdır
          </div>
          <div
            className="flex items-center gap-2 text-[10.5px] uppercase tracking-[0.14em]"
            style={{ fontFamily: "'JetBrains Mono', ui-monospace, monospace" }}
          >
            <span className="w-1.5 h-1.5 rounded-full bg-emerald-400" />
            <span>Tüm sistemler operasyonel</span>
          </div>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, items }) {
  return (
    <div>
      <div
        className="text-[10px] uppercase tracking-[0.16em] text-slate-500 mb-4"
        style={{ fontFamily: "'JetBrains Mono', ui-monospace, monospace" }}
      >
        {title}
      </div>
      <ul className="space-y-2.5 text-[13px]">
        {items.map((it, i) => {
          const isInternal = it.h.startsWith('/');
          return (
            <li key={i}>
              {isInternal ? (
                <Link to={it.h} className="hover:text-white transition">
                  {it.l}
                </Link>
              ) : (
                <a href={it.h} className="hover:text-white transition">
                  {it.l}
                </a>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
